function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 60 60",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30 60c16.569 0 30-13.431 30-30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30z",
  id: "1",
  fill: "#FB543F",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.278 19.414l-5.854-5.853M26.424 19.414l5.854-5.853M29.351 21.488l-10.938 17.51M29.351 21.488l10.938 17.51",
  id: "Shape",
  stroke: "#FFF",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  stroke: "#FFF",
  strokeLinejoin: "round",
  d: "M35.907 32.275l-6.573 4.683-6.539-4.65"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.351 46.106V22.04",
  id: "Shape",
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));